import { render, staticRenderFns } from "./SMSBrandNameRegisterTransaction.vue?vue&type=template&id=2fea5f7e"
import script from "./SMSBrandNameRegisterTransaction.vue?vue&type=script&lang=js"
export * from "./SMSBrandNameRegisterTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports